import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value;
    disabled;
    formData = {
        value: this.$props.value,
    };
    changeValue(val) {
        this.$emit('update:value', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    get rules() {
        return {
            value: [
                { required: true, message: this.inputPlaceholder, trigger: 'blur' },
                { pattern: this.getPattern(), message: this.inputPlaceholder, trigger: 'blur' },
            ],
        };
    }
    getPattern() {
        return /^([1-9]|[1-9]\d|[1-5]\d\d|600)$/;
    }
    get inputPlaceholder() {
        return this.$t('thresholdInputRule');
    }
};
__decorate([
    Prop()
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'RetentionTime',
        components: {},
        i18n: {
            messages: {
                zh: {
                    alarmTitle: '滞留时长阈值',
                    thresholdInputRule: '1~600',
                    sec: '秒',
                },
                en: {
                    alarmTitle: 'Detention time threshold',
                    thresholdInputRule: '1~600',
                    sec: 'Seconds',
                },
            },
        },
    })
], default_1);
export default default_1;
